import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
fallbackLng: 'en',
  lng: 'fa',
  resources: {
    en: { translations: require('./locales/en/translations.json') },
    fa: { translations: require('./locales/fa/translations.json') }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'fa'];
export default i18n;
